// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.81.0',
  revision: '09435aef1',
  branch: 'master',
  date: 'Tue, 11 Nov 2025 15:00:00 GMT'
};